<template>
  <v-navigation-drawer
    :value.sync="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    class="tw-pb-28 tw-border-0 md:tw-pb-0 md:tw-border-r-1 md:tw-border-light-gray md:tw-border-solid"
  >
    <!-- isValid isPdfDoc {{ isValid(selectedCompanyProductList.isPdfDoc) }}
    <br />
    isValid isEtax {{ isValid(selectedCompanyProductList.isEtax) }}
    <br />
    isValid isExchangeRate {{ isValid(selectedCompanyProductList.isExchangeRate) }} -->
     <!-- {{ selectedCompanyProductList }} -->
     <!-- userCompany {{ userCompany?.isAdmin }} -->
    <br />
    <div :class="`d-flex justify-center pt-5 pb-5`">
      <img
        src="@/assets/logo_phasi_charoen.svg"
        alt="ภาษีเจริญ"
        width="120"
        style="cursor: pointer"
        @click="goHome"
      />
    </div>
    <v-list v-if="!isItemLoading" style="margin-top: 10%">
      <!-- // etax // -->
      <template v-if="isValid(selectedCompanyProductList?.isEtax)">
        <div v-for="(item, index) in itemsPSC" :key="index + '_psc'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </template>
      <!-- // Ar automation // -->
      <template v-if="isValid(selectedCompanyProductList?.isPdfDoc)">
        <div v-for="(item, index) in itemsVendor" :key="index + '_vendor'">
          <menu-list :item="item" :companyID="companyID" :isPdfDoc="isValid(selectedCompanyProductList?.isPdfDoc)"></menu-list>
        </div>
      </template>
      <!-- // exchange rate // -->
      <div v-if="isValid(selectedCompanyProductList?.isExchangeRate)">
        <div v-for="(item, index) in itemsExchangeRate" :key="index + '_exchange'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
      <!-- // nsThaiSmartTax // --> 
      <div v-if="isValid(selectedCompanyProductList?.isNsThaiSmartTax)">
        <div v-for="(item, index) in itemsNsThaiSmartTax" :key="index + '_nstax'">   
          <div v-if="item.link==='Company.TaxBuyAverage' && selectedCompanyProductList?.isNsThaiSmartTaxAverage">
            <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list>
          </div>
          <div v-else-if="item.link !=='Company.TaxBuyAverage'" >
            <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list>
          </div>

         <!-- <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list> -->
        </div>
      </div>
      <!-- // top serv // -->
      <div v-if="isValid(selectedCompanyProductList?.isTopserv)">
        <div v-for="(item, index) in itemsTKC" :key="index + '_tkc'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
  <!-- when on the “student” company, render the student items -->
   <div
     v-if="isStudentCompany"
     class="tw-mb-4"
   >
     <div
       v-for="(item, idx) in filteredStudentMenu"
       :key="`student_${idx}`"
     >
       <menu-list
          :item="item"
          :companyID="companyID"
          :isCompanyAdmin="userCompany?.isAdmin"
        ></menu-list>
     </div>
   </div>
   <!-- otherwise, fall back to the normal AP-Automate items -->
   <div
     v-else-if="isValid(selectedCompanyProductList?.isApAutomate)"
     class=""
   >
     <div
       v-for="(item, idx) in itemsApAutomate"
       :key="`apauto_${idx}`"
     >
       <menu-list
         v-if="!item.onlydev || (userCompany?.isDeveloper || userCompany?.user?.isEngineer)"
         :item="item"
         :companyID="companyID"
         :isCompanyAdmin="userCompany?.isAdmin"
       ></menu-list>
     </div>
   </div>
      <!-- if none of those are true, then show the default menu -->
      <template v-if="!isValid(selectedCompanyProductList?.isEtax) && !isValid(selectedCompanyProductList?.isPdfDoc) && !isValid(selectedCompanyProductList?.isExchangeRate) && !isValid(selectedCompanyProductList?.isTopserv)  && !isValid(selectedCompanyProductList?.isNsThaiSmartTax) && !isValid(selectedCompanyProductList?.isApAutomate)">
        <div v-for="(item, index) in itemsPSC" :key="index">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </template>
      <!-- NS Fixed asset count -->
     <div v-if="isValid(selectedCompanyProductList?.isFixedAssetCount)">
        <div v-for="(item, index) in itemsNsFixedAsset" :key="index + '_nsfixedasset'">   
      
         <menu-list :item="item" :companyID="companyID" :isFixedAssetCount="isValid(selectedCompanyProductList?.isFixedAssetCount)"></menu-list>
        </div>
      </div>
      <div
        v-if="!isItemLoading && !isStudentCompany"
      >
        <menu-list :item="itemsSetting" :companyID="companyID"></menu-list>
      </div>
    </v-list>
    <!-- loading indicator -->
    <div v-else style="margin-top: 10%">
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MenuList from "@/components/admin/navigation/list.vue";
import router from "@/router";
import fc from "@/firebaseConfig";
const PRODUCT_GROUP = {
  PSC: "PSC",
  PDFAI: "PDFAI",
  FRX: "FRX",
};

const studentCompanyIds = [
  "mNX8y3SDqm5PcWLfdBGK",
  "6SyrlgRydgjKmrsCEwga",
  "HfqfyNYSNKY2JoVJitNb",
  "eOSDsGBKjFZfDBH0AdBK",
  "Z1gTJOuzuuJvuHWW3Ckt",
  "HedYda0bn4TPoRar37yN",
  "m2XXw3tgqqiHQgKa5wGy",
  "1mC0yZM960a0EnMeKDfk",
  "lgSH44502XPJcEdFlVGF",
  "ZRkN2AfCYj8AETTxPrK9",
  "skkfXYWtCWs5k63zDuS6",
  "s68PxpcLTIUld8LE8Qna",
  "k3Y47RAsQeE3al4WPId4",
  "vWM7EgPgozaQQSPrDtHr",
  "O7Rzy73u4feplqcxsbkq",
  "QEpgXxZizPNrosBFHlYk",
  "N7okw2LhO1bF2bobPLDi",
  "6CgB8ryPLgL53w8gGOPK",
  "ffTs69biO9hl3C5IEylS",
  "w4ownadTBkksSpPLeOBw",


  // 2nd train AJ.Authen
  "rMJMy0xIXWyUtPfIlyhP",
  "ubHXY3lL79FBSGSVpV4W",
  "HPms5KOkB61lKCXsAHjb",
  "4yLW2tTkrAI0nZbbDstr",
  "YLx35w2ytic4KLjYOJlK",
  "kY17MCMHmKx9o43jiZVV",
  "eY5g9kYNqb8mLf3tdU7x",
  "t3MKw6wvIdEK3Mp0fS8N",
  "1nzQenjiSyuUx9Q7ovab",
  "rPf7bZffYoxc2JJTgzkw",
  "GiYyJIrTLaUtlmXNezyR",
  "vlq9JFg95UQ7MJAmpAZ5",
  "XRWCTEKs0Bw1JPTLjB3k",
  "6tskPiUH5EoO7qMRBO0I",
  "JLYX7ZQo1hv1FAkuWADs",
  "HbgGRfhVR9tzIs50zviK",
  "LeaWCSALnh7IrH0H1Qg1",
  "Apff3BfykWfXMixKcans",
  "gBGTzbskzyVDL12umfjk",
  "PuwAIFXiTWOw9C7GMGHX",
  "rp0VN8MA5qCnWun99hQt",   
   "zWPGYOPXnczCdHfJwaj0",   
  "WSZIrVD2Q6wSeSy47eKj",
  "v68sS0gTbznjGh1eMW06",
  "qIWFangYP1n2BkNFlS9m",
  "UnGg1F3HjYLo4S5OvMcC",
  "rkZjNABAuKyk88Z0ye5s",
  "dB7qOY9e9yzhpKAlZSor",
  "rmCa4RCGLmhUQugmU5Xc",
  "KBE2PMJ8DaYlTZ4F2Mvk",
  "wWiNZPLY1msXkoZdxZGS",
  "HsvB5qzuuMD7ZHFO6QXG",
  "ehqqLjl8oFhRRI7HlFcY",
  "rGJ01vhA9ojyphZZn71X",
  "rXBzDZfcCAFa7E48T6ZD",
  "7o5QGjxXv1fzGV4LaESr",
  "OdzhpwXg8PJXo9hvDtn4",
  "QqxgzK3EOODmjNnFuCT3",
  "9P44cX8FmQkVYaF1TYgD",
  "GLSDVIwBNbaixnQsRU0O",
  "7wO0AWgMWXhrreD3El82",
  "P3durls98oouEpKCZKlW",
  "1xVQb7mlOzt1TnKdjSAy",
  "UE55GHOgVVKF0ZWSoyLE",
  "3yZAu5KmECdlSH05Crj9",
  "sHofOremv6JOAD1U0AKB",
  "yiMv5N6M8CPOVg4pPbiy",
  "GQSOFmqPM1UsCiROEMK9",
  "M8tcil6vAqc5kq7IaP8B",
  "zjk8l2OvZNEe88QqFJtW",
  "iT7LxTVKiqM6645jw9pP",
  "VDKxsCaNV5Sc025jUokT",
  "02Usy3t5lqKcYms8QZ0P",
  "wyTnS8XLG8O0thABiYBU",
  "skBNH8fY0Yxb1qzm28tX",
  "VxtBn5sRDTMKkZsRI5Ia",
  "H8G373ylxcUYY0qakmqx",
  "OnhdWT9jD4viudIZZ6ED",
  "YWnEaFVXuspHar3OSsvk",
  "yxiz53lBQMe8TugScJ4E",
];

export default {
  name: "NavigationDrawer",
  data: () => ({
    companyID: "",
    vendorListMerged: false,
    currentItems: [],
    unsubscribe: [],
  }),
  components: {
    MenuList,
  },
  computed: {
    ...mapState({
      userCompany: (state) => state.user.userCompany,
      drawer: (state) => state.drawer.open,
      itemsPSC: (state) => state.drawer.itemsPSC,
      isItemLoading: (state) => state.drawer.isItemLoading,
      itemsVendor: (state) => state.drawer.itemsVendor,
      itemsExchangeRate: (state) => state.drawer.itemsExchangeRate,
      itemsNsThaiSmartTax: (state) => state.drawer.itemsNsThaiSmartTax,
      itemsNsFixedAsset: (state) => state.drawer.itemsNsFixedAsset,
      itemsTKC: (state) => state.drawer.itemsTKC,
      itemsApAutomate: (state) => state.drawer.itemsApAutomate,
      itemsApAutomateStudent: (state) => state.drawer.itemsApAutomateStudent,
      itemsSetting: (state) => state.drawer.itemsSetting,
      vendorPOList: (state) => state.drawer.vendorPOList,
      vendorSOList: (state) => state.drawer.vendorSOList,
      selectedCompanyAutoDocConfig: (state) => state.companies.selectedCompanyAutoDocConfig,
      selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
    }),
    isStudentCompany() {
      return studentCompanyIds.includes(this.$route.params.companyId);
    },
    filteredStudentMenu() {
      // --- เงื่อนไขเดิม (commented out): ---
      // if (this.userCompany?.isAdmin || this.userCompany?.role === "admin") {
      //   return this.itemsApAutomateStudent;
      // }
      // return this.itemsApAutomateStudent.filter(
      //   (item) => item.link === "Company.AccountsPayableStudent"
      // );
      // --- ปัจจุบัน: แสดงทุกเมนู ไม่สน role ---
      return this.itemsApAutomateStudent;
    },
  },
  created() {
    this.companyID = this.$route.params.companyId;
    // if (this.companyID === "Eh3hXbMX82kanH0deWiv") {
      this.getCompanyAutoDocConfig();
      this.getCompanyProductList();
    // }

    if (this.companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: this.companyID });
    }

  },
  beforeDestroy() {
      this.unsubscribe.forEach((unsubscribe) => {
        unsubscribe();
      });
  },
  methods: {
     isCompanyAdminCheck(item) {
    return item.isOnlyAdmin && (
      !item.onlydev || 
      (this.userCompany?.isDeveloper || this.userCompany?.user?.isEngineer)
    );
  },
    getCompanyAutoDocConfig() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyAutoDocConfig", { companyId });
    },
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    isValid(value) {
      return (
        value !== undefined && value !== null && value !== "" && value === true
      );
    },
    goHome: function () {
      router.push("/");
    },
    mergeVendorListOnce() {
      this.$store.commit("drawer/mergeVendorList");
      this.$store.commit("drawer/setVendorListMerged");
    },
    setNewPOList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        vendorCode: item.vendorCode,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        this.vendorPOList.length !== newPoList.length ||
        isDifferent
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.mergeVendorListOnce();
      }
    },
    setNewVendorList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
      

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));
      const newSoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentSOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);
      const isDifferentSO =
        JSON.stringify(this.vendorSOList) !== JSON.stringify(newSoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        isDifferent ||
        isDifferentSO
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.$store.commit("drawer/setVendorSOList", newSoList);
        this.mergeVendorListOnce();
      }
    },
    setTkcItem(){
      const companyId = this.$route.params.companyId;
      const snapshot = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV").onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            const tkcItem = data.branches.map((item) => ({
              text: `สาขา${item.branchName} (${item.endsWith})`,
              link: "Company.DocumentTOPSERVBranch",
              endsWith: item.endsWith,
            }));
            this.$store.commit("drawer/setitemsTKC", tkcItem);
          }
        }
      );
      this.unsubscribe.push(snapshot);
    }
  },
  watch: {
    selectedCompanyAutoDocConfig() {
      // this.setNewPOList();
      this.setNewVendorList();
      // console.log("Watch -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
    },
    selectedCompanyProductList() {
      if (this.selectedCompanyProductList?.isTopserv) {
        this.setTkcItem();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-list {
  margin-bottom: 100px;
}
</style>
